import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getUserCoursesQuery,
  getUserCoursesIdQuery,
  getStaffCoursesQuery,
  getStaffCoursesStudentsQuery,
  getStudentCourseTagsQuery,
  getStaffCoursesV2BasicDetailsQuery,
  fetchMBSpontePortalUrlQuery,
} from "./TeacherQuery";
import { getNotificationsCountQuery } from "modules/CommonQuery";

//Don't use it. Will deplicate soon. Use getUserCoursesFromCache instead
export const getStaffCoursesFromCache = (user_id, isCurriculumProgramFree) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffCoursesQuery,
      variables: {
        id: user_id,
        isCurriculumProgramFree,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getUserCoursesFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUserCoursesQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getUserCoursesIdFromCache = ({ id, type, filters }) => {
  try {
    const queryData = client.readQuery({
      query: getUserCoursesIdQuery,
      variables: {
        id,
        type,
        filters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getNotificationsCountFromCache = ({
  id,
  type,
  notificationCategoryFilter,
}) => {
  try {
    const queryData = client.readQuery({
      query: getNotificationsCountQuery,
      variables: {
        id,
        type,
        notificationCategoryFilter,
      },
    });
    return _.get(queryData, "node.notification", {});
  } catch (e) {
    return {};
  }
};

export const getStaffCoursesStudentsFromCache = ({
  id,
  searchText,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffCoursesStudentsQuery,
      variables: {
        id,
        searchText,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStaffCoursesV2BasicDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffCoursesV2BasicDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getStudentCourseTagsFromCache = ({ id, courseIds }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentCourseTagsQuery,
      variables: {
        id: id,
        courseIdsFilter: { courseIds },
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const fetchMBSpontePortalUrlFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: fetchMBSpontePortalUrlQuery,
      variables,
    });
    return _.get(queryData, "integration.fetchMBSpontePortalUrl", {});
  } catch (e) {
    return {};
  }
};
